<template>
  <div class="gift-history app-container">
    <div class="global-header-wrap">
      <h3>
        卡包操作历史
      </h3>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <!-- <button class="global-button-style" @click="addCode">
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button> -->
      </div>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination :pageSize="params.limit" :total="total" @pageNum="pageNum" />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    appTable,
    pagination
  },
  mixins: [listMixin],
  computed: {
    ...mapGetters(["appendPopup"]),
    tableProps() {
      let tableProps = [
        {
          prop: "user.nickname",
          obj: true,
          label: "修改人"
        },
        {
          prop: "operation",
          label: "操作"
        },
        {
          prop: "giftContent",
          label: "修改内容"
        },
        {
          prop: "updatedAt",
          label: "时间"
        }
        // {
        //   prop: "handle",
        //   label: this.$t("org.manage"),
        //   btn: [
        //     this.$t("commonMsg.edit"),
        //     this.$t("commonMsg.del"),
        //     this.$t("sale.gift.handle")
        //   ]
        // }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      params: {
        target: this.$route.query.id,
        limit: 20,
        page: 1
      },
      total: 0,
      tableData: []
    };
  },

  methods: {
    async getList() {
      try {
        let res = await this.$http.getGiftOpeHistory(this.params);
        this.tableData = res.data;
      } catch (error) {}
    },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.gift-history-header {
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    // margin-right:10px;
  }
}
.gift-history-pagination {
  padding: 10px;
  text-align: right;
}
.gift-import-btn {
  margin-top: 10px;
}
</style>
